// Выбор выпущенного пакета КС-3 для переноса в накопительную ленту ПА.
// Модуль без импортов значений: его проверяет
// `cd frontend && node --test src/pages/Smeta/accumulations/ksPackagePick.test.mjs`
// (Node сам снимает типы, Node ≥ 22.18).

/** Ведомость и договор, к которым относятся выбор пакета и итог переноса. */
export function pickScope(ledgerId: string, contractId: string | null | undefined): string {
  return `${ledgerId}|${contractId ?? ''}`;
}

/** Пакет, выбранный сметчиком, — вместе с ведомостью и договором, где выбран. */
export interface KsPackagePick {
  scope: string;
  packageId: string;
}

/** В ленту переносится только выпущенный пакет: `issued` или `archived`. */
export function releasedKsPackages<T extends { status: string }>(items: readonly T[]): T[] {
  return items.filter((p) => p.status === 'issued' || p.status === 'archived');
}

/**
 * Пакет, который уйдёт на сервер: выбран в ЭТОЙ ведомости при ЭТОМ договоре и
 * есть в актуальном списке выпущенных пакетов. Иначе — пусто: выбор из другой
 * ведомости и пакет, которого в списке уже нет (список сменился вместе с
 * договором или ещё не загружен), не отправляются.
 */
export function pickedKsPackageId(
  pick: KsPackagePick,
  scope: string,
  released: readonly { id: string }[],
): string {
  if (pick.scope !== scope || !pick.packageId) return '';
  return released.some((p) => p.id === pick.packageId) ? pick.packageId : '';
}
